



import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../_services/index';
import 'rxjs/add/operator/map'
import { Observable } from 'rxjs/Observable';
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2'
import { environment } from '.../../environments/environment';


import { process, State, aggregateBy } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import {
  GridDataResult,
  DataStateChangeEvent
} from '@progress/kendo-angular-grid';


declare var $: any;

const distinctZone= data => data.filter((x, idx, xs) => xs.findIndex(y => y.zoneName === x.zoneName) === idx); 
const distinctWard= data => data.filter((x, idx, xs) => xs.findIndex(y => y.wardName === x.wardName) === idx); 
const distinctWards= data => data.filter((x, idx, xs) => xs.findIndex(y => y.Wards === x.Wards) === idx); 
@Component({
  selector: 'uccMapping',
  templateUrl: 'uccMapping.component.html',
})

export class UccMappingComponent {
  search: any
  Employeedata: any
  prjId: any;
  userId: any;
  showLoader: any;
  collectionList: any;
  dataRangeModal: any;
  startDate: any;
  endDate: any;
  defaultStartDate: any;
  defaultEndDate: any;
  uccMobileList: any;
  dateLink: any;
  geocoder: any;
  uccRecardStatus = false;
  address: any;
  totalAmount: any
  totalTransaction: any
  totalhouseHold:any 
  zoneList: any
  wardList: any
  zoneId: any
  wardId: any
  uccUser: any
  mobile: any
  route: any;
  authtoken: any;

  markerStart: any;
	markerEnd: any;

  routePath: any;
  public map: any;
  public gridDataCouponCollection: GridDataResult
  public distinctZone: any[]
  public distinctWard: any[]
  public distinctWards: any[]
  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  amount: boolean = false;
  resultFill: any
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  private loadProducts(): void {

    this.gridData = process(this.uccMobileList, { group: this.groups });
  }
  public gridData: GridDataResult
  public allData(): ExcelExportData {
    const result: ExcelExportData = {

      data: this.resultFill
    };
    return result;
  }
  public state: State = {
    skip: 0,
    take: 20,
    // Initial filter descriptor
    // group :[{ field: 'wardName', aggregates: this.aggregates }],
    filter: {
      logic: 'and',
      filters: []
    }
  };



  constructor(private http: HttpClient, private auth: AuthService, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });

    this.authtoken = JSON.parse(localStorage.getItem('authData'));

    this.mobile = null
    this.zoneId = null;
    this.wardId = null;
    var firstDay = new Date();
    var lastDay = new Date();
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defaultEndDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.dataRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() } };


   
    

    this.allData = this.allData.bind(this);
  }

  importUccMobileReportAll() {
    window.open(environment.apiUrl + "uccNew/uccCollectionExl?prjId=" + this.prjId);
  }

  importUccMobileReport() {
    var data = this.uccMobileList
    const ws_name = 'importUccMobileReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'uccMobileReport.xlsx');
  }

  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }


  // deleteConfirmation(data){
  //   Swal({
  //     title: 'Are you sure?',
  //     text: "You won't be able to revert this!",
  //     type: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, Convert it!'
  //   }).then((result) => {
  //     if (result.value) {
  //       this.deleteTransaction(data)
  //     }
  //   })
  // }


  // deleteTransaction(data){
  //   this.http.get(environment.apiUrl + 'ucc/deleteCollection' + "?pushId=" + data.pushId).subscribe(data =>{ 
  //     var result:any
  //      result = data
  //     if (result.status == 200) {
  //       var msg = result.msg
  //       Swal(
  //         '',
  //         msg,
  //         'success'
  //       )

  //     } else {
  //       var msg = result.msg
  //       Swal(
  //         msg,
  //         'error'
  //       )
  //     }

  //   }); 
  // }

  cleanData(array) {
    for (var i = 0; i < array.length; i++) {
      delete array[i].token
      delete array[i].deviceId
      delete array[i].tollfree
      delete array[i].vehId
      //delete array[i].pushId
      delete array[i].vehNo
      delete array[i].zoneId
      delete array[i].wardId
      delete array[i].prjAddress
      delete array[i].amountSqlCode
      delete array[i].prjId
      // delete array[i].geoAddress
      delete array[i].collectorUid
      //delete array[i].paymentDate
    }
    return array
  }

  getZone() {
    this.http.get(environment.apiUrl + 'consumer/getZoneByProject?prjid=' + this.prjId + '&oemid=7').subscribe(data => {
      this.zoneList = data;

    });
  }

  getAllWard() {
    this.http.get(environment.apiUrl + 'consumer/getZoneByProject?prjid=' + this.prjId + '&oemid=8').subscribe(data => {
      this.wardList = data;

    });
  }

  getUccUser() {
    this.http.get(environment.apiUrl + 'uccnew/uccMobileUser').subscribe(data => {
      var result: any
      result = data
      console.log(result)
      this.uccUser = result.data

    });
  }

  getWard() {
    this.http.get(environment.apiUrl + 'uccnew/getWardByProject?prjid=' + this.prjId + '&userId=' + this.userId).subscribe(data => {
      var result: any
      result = data
      this.zoneList = []
      for (var i = 0; i < result.length; i++) {
        result[i].id = result[i].entityid
        result[i].entityname = result[i].entityName
        this.zoneList.push({ entityname: result[i].Zone, id: result[i].ZONEID })
        this.zoneId = result[i].ZONEID
      }
      this.wardList = data;
      if (this.wardList.length == 0) {
        this.getAllWard()
        this.getZone();
        this.getUccReceiptReport(this.startDate, this.endDate);
      } else {
        this.getUccReceiptReport(this.startDate, this.endDate);
      }
      console.log("this.ward", this.wardList)
    });
  }
  //  /
  //  * GET UCC RECEIPT REPORT 
  //  */
  getUccReceiptReport(stDate, edDate) {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'ucc/getUccMapping?prjId=' + this.prjId + '&fromDate=' + stDate + '&toDate=' + edDate ).subscribe(data => {
    
      this.resultFill = data

    


      this.gridData = process(this.resultFill, this.state);
      this.loaderService.display(false);
        
       var totalAmount = 0 ;
       var totalCollector = this.resultFill.length;
       var totalHouseHold = 0 ;
          
       for (let index = 0; index < this.resultFill.length ; index++) {
        totalAmount  += this.resultFill[index].amount;
        totalHouseHold  += this.resultFill[index].totalEntry;


       }
      this.totalAmount = totalAmount 

      this.totalTransaction = totalCollector

      this.totalhouseHold = totalHouseHold

      // console.log('260',result);
      
      // this.uccMobileList = result.result
      // console.log("test", this.uccMobileList)
      // this.totalTransaction = result.total.total
      // this.totalAmount = result.total.amount
      // if (this.uccMobileList.length > 0) {
      //   this.loaderService.display(false);
      //   this.uccRecardStatus = false;
      //   this.distinctZone = distinctZone(this.uccMobileList)
      //   this.distinctWard = distinctWard(this.uccMobileList)
      //   this.distinctWards = distinctWards(this.uccMobileList)
      //   this.gridData = process(this.uccMobileList, this.state);
      //   $('.placeHolder').hide();
      //   this.amount = false
      // } else {
      //   this.gridData = process(this.uccMobileList, this.state);
      //   this.uccRecardStatus = true;
      //   this.loaderService.display(false);
      //   $('.placeHolder').hide();
      //   this.amount = true
      // }
    });
  }

  // onSelect(data) {
  //   console.log(data);
  //   if (data.item == 'Delete') {
  //     this.alterUccReceipt(data.dataItem.receiptNo);
  //   }
  //   else {
  //     this.updateUccReciept(data.dataItem.receiptNo)
  //   }
  // }

  onSelect(data){
    // console.log(receiptNo);
    var type = data.item
    var receiptNo = data.dataItem.receiptNo

    // var apiUrl =  environment.apiUrl + 'invoice/changeState', data
    // var data = {
    //   INVOICEID: item.invoiceID,
    //   DATE: new Date(),
    //   STAGE: '9',
    //   REMARK: this.statusRemark,
    //   USERID: this.userId,
    //   NEXTACTIONDATE: null
    // };

    Swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    })
    .then((result) => {
      if (result.value) {
        this.http.get(environment.apiUrl + 'ucc/deleteUccReceipt?' + "receiptNo=" + receiptNo).subscribe((data) => {
          var result: any
            result = data
            if (result.code == 200) {
                var msg = result.msg
                Swal(
                    '',
                    msg,
                    'success'
                )
                this.getUccReceiptReport(this.startDate, this.endDate)

            } else {
                var msg = result.msg
                Swal(
                    msg,
                    'error'
                )
                this.getUccReceiptReport(this.startDate, this.endDate)
            }
        });
      }
    });
  }

  // updateUccReciept(receiptNo){
  //   console.log(receiptNo);
  // }

  onDateRangeChanged(dataRange) {
    if (this.startDate != '' || this.startDate != null || this.startDate != undefined) {
      var startDate = dataRange.beginDate.year + "-" + dataRange.beginDate.month + "-" + dataRange.beginDate.day
      var endDate = dataRange.endDate.year + "-" + dataRange.endDate.month + "-" + dataRange.endDate.day
      this.startDate = moment(startDate).format('YYYY-MM-DD');
      this.endDate = moment(endDate).format('YYYY-MM-DD');
      this.getUccReceiptReport(this.startDate, this.endDate)
    }
    else {
      this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
      this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
      this.getUccReceiptReport(this.startDate, this.endDate)
    }
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.loaderService.display(true);
    this.state = state;
    this.gridData = process(this.resultFill, this.state);
    this.loaderService.display(false);
  }

  // viewMapModal(data){  
  //     console.log(data)
  //     this.uccRecardStatus=false;
  //     this.address=data.consumerAddress
  //     $("#viewMapModal").modal("show"); 
  //     this.googleMap(data.geolocation._latitude,data.geolocation._longitude); 

  // }


  /*
   * Get LAT LNg by Address
  */
  // googleMap(lat, lng) {
  //   var myLatLng = {lat:lat, lng: lng}; 
  //   var map = new google.maps.Map(document.getElementById('googleMap'), {
  //     zoom: 17,
  //     center: myLatLng
  //   }); 
  //   var marker = new google.maps.Marker({
  //     position: myLatLng,
  //     map: map,
  //     title: 'Hello World!'
  //   });
  //   } 

  selectZone(data) {
    if (data) {
      this.getUccReceiptReport(this.startDate, this.endDate);
    } else {
      this.zoneId = null
      this.getUccReceiptReport(this.startDate, this.endDate);
    }
  }

  selectUser(data) {
    if (data) {
      this.getUccReceiptReport(this.startDate, this.endDate);
    } else {
      this.mobile = null
      this.getUccReceiptReport(this.startDate, this.endDate);
    }
  }

  selectWard(data) {
    if (data) {
      this.getUccReceiptReport(this.startDate, this.endDate);
    } else {
      this.wardId = null
      this.getUccReceiptReport(this.startDate, this.endDate);
    }
  }

  ngOnInit() {
    this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    // this.geocoder = new google.maps.Geocoder;   
    this.getUccUser()
    this.getWard();

    var myOptions = {
			center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
			zoom: 13,

			mapTypeControl: true,
			mapTypeControlOptions: {
				style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
				position: google.maps.ControlPosition.TOP_CENTER
			},
			zoomControl: true,
		  scaleControl: true,
			fullscreenControl: true
		};
		this.map = new google.maps.Map(document.getElementById('map'), myOptions);
  }


 async  vehicleMapTrack(dataItem){


  console.log('493',dataItem);
  
      var DEVICEID = dataItem.collectorMobile
      var curdate = this.startDate


   
      
       
     
     let response = await fetch(
      environment.apiUrl + 'ucc/getUccMappingRoute'+'?DEVICEID='+DEVICEID+'&MapDate='+curdate,
          {
          method: 'get',
          headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: this.authtoken.token
          }
         }
      );

      let result = await response.json();
 
 
      $('#allendanceDetailModal').modal('show'); 

      this.plotStartAndEndPoint(result)

      this.createRoute(this.map, result);



    
  }
  
  createRoute(map, pathCoords) {
    var i, route, marker;
     
    var polyCords = [] ;
    for (i = 0; i < pathCoords.length; i++) {
        polyCords.push({ lat: JSON.parse(pathCoords[i].lat), lng: JSON.parse(pathCoords[i].lng) });
    }
    var car =
        'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';
    var icon = {
        path: car,
        scale: 1,
        strokeColor: 'white',
        strokeWeight: 0.1,
        fillOpacity: 5,
        fillColor: '#35370C',
        offset: '2%',
        // rotation: parseInt(heading[i]),
        anchor: new google.maps.Point(10, 25) // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
    };
    this.routePath = polyCords;


    console.log('543',polyCords);
    
    this.route = new google.maps.Polyline({
        path: polyCords,
        strokeColor: '#E2EF16',
        strokeOpacity: 4.0,
        strokeWeight: 5,
         
        map: map
    });

   
   

   // this.zoomToObject(this.route);
}

// zoomToObject(obj) {
//   var bounds = new google.maps.LatLngBounds();
//   var points = obj.getPath().getArray();
//   for (var n = 0; n < points.length; n++) {
//       bounds.extend(points[n]);
//   }
//   this.map.fitBounds(bounds);
// }


plotStartAndEndPoint(data) {

   var len = data.length  - 1 ;
   
  var startLat =  JSON.parse(data[0].lat)
  var startLng =  JSON.parse(data[0].lng)

  var endLat =  JSON.parse(data[len].lat)
  var endLng =  JSON.parse(data[len].lng)

  var start = new google.maps.LatLng(startLat, startLng);
  var end = new google.maps.LatLng(endLat, endLng);
  this.markerStart = new google.maps.Marker({
    position: start,
    map: this.map,
    icon: 'assets/img/start.png'

    // labelClass: 'labels', // the CSS class for the label
    // labelStyle: { opacity: 1.0 }
  });
  this.markerEnd = new google.maps.Marker({
    position: end,
    map: this.map,
    icon: 'assets/img/end.png'
  });
}







}


// WEBPACK FOOTER //
// ./src/app/reports/uccReport/uccMapping.Component.ts